<template>

    <!-- Prompt Layout -->
    <div class="prompt-container text-center">

        <!-- Layout body -->
        <slot name="body"></slot>

        <!-- Bottom button -->
        <div class="fixed-bottom-buffer my-6" v-if="hasBottomButton"></div>
        <div class="fixed-bottom full-width my-6 px-7" v-if="hasBottomButton">
            <slot name="bottom-button"></slot>
        </div>

    </div>

</template>

<script>
    export default {
        computed: {
            hasBottomButton: function() {
                return this.$slots['bottom-button']
            }
        }
    }
</script>

<style scoped>
    .modal-container--short .prompt-container {
        min-height: 0;
    }

    .prompt-container {
        position: relative;
        margin-right: 3.5rem;
        margin-left: 3.5rem;
        margin-bottom: 1rem;
        min-height: calc(100vh - 4.5rem);
    }
    .fixed-bottom-buffer, .fixed-bottom {
        min-height: 3.5rem;
    }
    .full-width {
        margin-right: -3.5rem;
        margin-left: -3.5rem;
    }
</style>
